export enum ApiClientExceptionErrorCode {
  EmailUsed = 'EmailUsed',
  ServicePurchaseRequired = 'ServicePurchaseRequired',
  CouldNotAddClientToClass = 'CouldNotAddClientToClass',
  CouldNotCancelBooking = 'CouldNotCancelBooking',
  UserNotLoggedIn = 'UserNotLoggedIn',
  BadData = 'BadData',
  NotFound = 'NotFound',
  InvalidLoginCredentials = 'InvalidLoginCredentials',
  InvalidPassword = 'InvalidPassword',
  GiftCardBalanceMismatch = 'GiftCardBalanceMismatch',
  ClientMissingFromSite = 'ClientMissingFromSite',
  ClientNotFound = 'ClientNotFound',
  ClientMigrationFailed = 'ClientMigrationFailed',
  ClassRequiresPayment = 'ClassRequiresPayment',
  ScaExemptionDenied = 'ScaExemptionDenied',
  SelfReferralBlocked = 'SelfReferralBlocked',
  InsufficientCredits = 'InsufficientCredits',
  /** Refus du garde-fou des sites de test (local, stagings ; jamais en prod) : écriture Mindbody bloquée. */
  TestSiteGuard = 'mm_local_guard',
}

export interface IApiClientException {
  Message: string;
  Code: number;
  ErrorCode: ApiClientExceptionErrorCode;
}
